module.exports = __webpack_public_path__ + "static/images/event/alert_triangle_red.png";